import { createContext } from 'react';
import { AffiliateCode } from '@src/constants/affiliate';
import { PlanCode } from '@src/helpers/plan-constants.helper';
import { PetProfile } from '@src/@types/pets';

export type AffiliateContextShape = {
  showExistingPetModal: boolean;
  batchId: string;
  planCode: PlanCode;
  affiliateCode: AffiliateCode;
  affiliatePet: PetProfile;
};
export const AffiliateContext = createContext<AffiliateContextShape>({
  showExistingPetModal: false,
  batchId: '',
  planCode: '' as PlanCode,
  affiliateCode: '' as AffiliateCode,
  affiliatePet: {} as PetProfile,
} as AffiliateContextShape);
